import React, { useState } from "react";
import LineBtn from "../../../Button/LineBtn";
import UpdateReportLimitCntModal from "./UpdateReportLimitCntModal";

interface ReportLimitCntBtnProps {
  reportLimitCnt: number;
  getLoginCheckData: () => Promise<void>;
}

export default function ReportLimitCntBtn({
  reportLimitCnt,
  getLoginCheckData,
}: ReportLimitCntBtnProps) {
  const [updateReportLimitCntModal, setUpdateReportLimitCntModal] =
    useState(false);

  return (
    <>
      <LineBtn
        btnText={`로그인 체크 기준 횟수: ${reportLimitCnt}`}
        icon="settings"
        btnClickEvent={() => setUpdateReportLimitCntModal(true)}
      />

      {updateReportLimitCntModal && (
        <UpdateReportLimitCntModal
          closeEvent={() => setUpdateReportLimitCntModal(false)}
          confirmEvent={() => getLoginCheckData()}
        />
      )}
    </>
  );
}
